import React from "react";

import { useIntl } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/enum";

import ListViewSubHeader from "@app/component/view/ListView/components/SubHeader";

import styles from "./Subheader.module.scss";

interface Props {
  totalFilteredRecords: number;
  totalRecords: number;
}

const Subheader: React.FC<Props> = ({ totalFilteredRecords, totalRecords }) => {
  const intl = useIntl();

  return (
    <ListViewSubHeader
      entityType={EntityType.DEAL}
      iconContainerClassName={styles.iconContainer}
      mapViewLegacyPath="/deals/map"
      title={intl.formatMessage({
        id: "dealList.subheader.title",
        defaultMessage: "Deals",
        description: "Title of subheader on Deal List page",
      })}
      totalFilteredRecords={totalFilteredRecords}
      totalRecords={totalRecords}
    />
  );
};

export default Subheader;
